<template>
  <span
    class="aha-checkbox"
    :class="[
      `aha-checkbox--${size}`,
      {
        'aha-checkbox--disabled': disabled,
        'aha-checkbox--checked': checked,
        'mr-2': hasMarginRight,
      },
    ]"
  >
    <i class="fa fa-check" v-if="checked" />
  </span>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    hasMarginRight: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
}
</script>

<style lang="scss">
.aha-checkbox {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #D3D7E1;
  background: #FFF;
  border-radius: 4px;

  i {
    font-size: 14px;
    color: #4F9BF3;
  }
}

.aha-checkbox--md {
  width: 20px;
  height: 20px;
}

.aha-checkbox--lg {
  width: 24px;
  height: 24px;
}

.aha-checkbox--checked {
  border: 2px solid #4F9BF3;
}

.aha-checkbox--disabled {
  border: 2px solid #D1D1D1;

  i {
    color: #D1D1D1;
  }
}
</style>
